<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14zq92w/tc-custom/9780062059772.jpg?1727321088696" alt="This image is the cover for the book Tragedy of the Templars"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tragedy of the Templars
      </h1>
      <p class="bookDescription body article font2">
        <b>The acclaimed medieval historian chronicles the rise of Templar powers in the Levant—and the saga of their destruction.</b><br/><br/> Founded on Christmas Day 1119 in Jerusalem, the Knights Templar was a religious order dedicated to defending the Holy Land and its Christian pilgrims in the decades after the First Crusade. Legendary for their bravery and dedication, the Templars became one of the wealthiest and most powerful bodies of the medieval world—and the chief defenders of Christian society against growing Muslim forces.<br/><br/> In <i>The Tragedy of the Templars: The Rise and Fall of the Crusader States</i>, Haag masterfully details the conflicts and betrayals that sent this faction of powerful knights spiraling from domination to condemnation.<br/><br/> This stirring and thoroughly researched work of historical investigation includes maps and full-color photographs of important cultural sites, many of which doubled as battlefields during the Crusades. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Haag
      </h2>
      
      <p class="authorDescription body article"><P>Historian and writer Michael Haag has written widely on the Egyptian, Classical,and Medieval worlds. He is the author of <I>The Templars: The History &#38; the Myth</I>and <I>Alexandria: City of Memory</I>, a definitive study of Cavafy, Forster, and LawrenceDurrell in the city, as well as travel guides to Syria, Lebanon, and Egypt. He livesin London.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5933a891